import { ObjectType } from "features/types";

export interface FiltersState {
  filters: Filter[];
  activeFiltersCount: number;
  activeFilters: ActiveFilter[];
  openedFilter: string;
  maxPrice: number;
  initialLoad: boolean;
}

export interface Filter {
  title: string;
  name: string;
  availableFilters: string[];
  _id: string;
  objectType: ObjectType;
}

export interface ActiveFilter {
  name: string;
  activeFilters: string[];
}

export interface PageWithFilter {
  selectors: {
    activeFiltersSelector: any;
    openedFilterSelector: any;
  };
  actions: {
    setOpenedFilter: any;
    setActiveFilters: any;
    setActiveFiltersCount: any;
    setFilteredProducts: any;
    fetchProducts: any;
  };
}

export enum PageWithFilterType {
  category = "category",
  accessories = "accessories",
  promotions = "promotions",
}
